import { createContext, ReactNode, useContext, useState, useCallback } from 'react';

type NotificationModalContextData = {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  toggleModal: () => void;
}

type Props = {
  children: ReactNode;
}

const NotificationModalContext = createContext({} as NotificationModalContextData);

export function NotificationModalProvider({ children }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggleModal = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  return (
    <NotificationModalContext.Provider value={{ isOpen, openModal, closeModal, toggleModal }}>
      {children}
    </NotificationModalContext.Provider>
  );
}

export function useNotificationModal() {
  const context = useContext(NotificationModalContext);
  
  if (!context) {
    throw new Error('useNotificationModal must be used within a NotificationModalProvider');
  }

  return context;
}

